@use "../../../../../../src/styles/Colors.scss" as Colors;
@use "../../../../../../src/styles/Constants.scss" as Constants;

.modal {
	width: Constants.$val-modal-xl !important;
	display: flex !important;
	justify-content: center !important;
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);

	&__big-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: Constants.$val-fontSizeXBig;
		font-weight: bold;
		overflow: initial !important;

		&::before,
		&::after {
			display: none;
		}

		&__thin {
			font-size: Constants.$val-fontSizeXBig;
			font-weight: normal;
		}
	}

	&__body {
		display: flex;
		align-items: flex-start;
		justify-content: center;
		flex-direction: column;
	}

	.img-preview {
		max-height: 500px;
		max-width: 600px;
	}

	.duplicate-name-error {
		margin-top: Constants.$val-spacing-s;
		color: Colors.$col-red;
	}
}

.settings-actions {
	font-size: Constants.$val-fontSizeXXXBig;

	&__dropdown-toggle {
		color: Colors.$col-black;
		justify-content: center;
		cursor: pointer;

		&:focus,
		&:hover,
		&:active,
		&:active:hover,
		&:active:focus {
			color: Colors.$col-black;
		}
	}
}

input {
	&.input-text-field {
		border: 1px solid Colors.$col-greyMid;
		border-radius: Constants.$val-borderRadius;
		background-color: Colors.$col-white;
		font-size: Constants.$val-fontSizeRegular;
		line-height: Constants.$val-lineHeightRegular;
		outline: none;
		height: Constants.$val-fieldSize;
		width: -webkit-fill-available;
	}
}